import { init as initFullStory, FullStory } from "@fullstory/browser";
import { REACT_APP_FULLSTORY_ID } from "config";
import { isAppRunningInDev } from "utils/utils";

declare global {
  interface Window {
    isInitFullStoryLocally: boolean;
  }
}

const isDeveloperTestingFS = false;

const initializeFullStory = (samplingRate?: number) => {
  const initializeChangeRate = samplingRate || 0;

  if (
    (!window.location.origin.match(/localhost/gi) || isDeveloperTestingFS) &&
    fullStoryRanzdomizer(initializeChangeRate)
  ) {
    initFullStory({ orgId: REACT_APP_FULLSTORY_ID });
    window.isInitFullStoryLocally = true;

    if (isAppRunningInDev()) {
      console.log("** FS INITIALIZED");
    }
  }
};

const trackCustomEventFullStory = (customEventName: string, params: { [key: string]: any } = {}) => {
  if (window.isInitFullStoryLocally) {
    FullStory("trackEvent", {
      name: customEventName,
      properties: params,
    });

    if (isAppRunningInDev()) {
      console.log("** FS TRACK: ", customEventName);
    }
  } else {
    if (isAppRunningInDev()) {
      console.log("** FS DO NOT TRACK: ", customEventName);
    }
  }
};

const fullStoryRanzdomizer = (
  /**
   * Integer 1 to 100, 1% to 100%.
   */
  chanceRate: number,
) => {
  if (!chanceRate) {
    return false;
  }

  const randomNumber = Math.floor(Math.random() * 100) + 1;

  return randomNumber <= chanceRate;
};

export { trackCustomEventFullStory, initializeFullStory };
